// extracted by mini-css-extract-plugin
export default {"fieldView":"FieldView_fieldView__pWgxF","labelWrapper":"FieldView_labelWrapper__zHFho"};